"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getControllers = void 0;
/**
 * Collects all exported controllers from the client
 * application as an array.
 */
var getControllers = function () {
    var controllers;
    if (!controllers) {
        var root = global || window;
        controllers = root['Bernie'] ? root['Bernie']['controllers'] : null;
        if (!controllers) {
            throw new Error('Could not find "Bernie.controllers" on global object.');
        }
    }
    if (controllers instanceof Function) {
        controllers = controllers();
    }
    if (!Array.isArray(controllers)) {
        throw new TypeError('Controllers should be exported as an array of Controller class definitions.');
    }
    return controllers.map(function (controller) { return new controller(); });
};
exports.getControllers = getControllers;
//# sourceMappingURL=get-controllers.js.map